{
  "emojies": {
    "happy": [
      {
        "name": "blinking-happy",
        "filename": "blinking-happy.png",
        "path": "/emojies/blinking-happy.png",
        "description": "Happy blinking expression"
      },
      {
        "name": "happy-energy",
        "filename": "happy-energy.png",
        "path": "/emojies/happy-energy.png",
        "description": "Happy with high energy"
      },
      {
        "name": "happy-looking-to-right",
        "filename": "happy-looking-to-right.png",
        "path": "/emojies/happy-looking-to-right.png",
        "description": "Happy looking to the right"
      },
      {
        "name": "happy-tongue-out",
        "filename": "happy-tongue-out.png",
        "path": "/emojies/happy-tongue-out.png",
        "description": "Happy with tongue out"
      },
      {
        "name": "laughing",
        "filename": "laughing.png",
        "path": "/emojies/laughing.png",
        "description": "Laughing expression"
      },
      {
        "name": "laughing-crying",
        "filename": "laughing-crying.png",
        "path": "/emojies/laughing-crying.png",
        "description": "Laughing so hard crying"
      },
      {
        "name": "smiling-I-am-pro",
        "filename": "smiling-I-am-pro.png",
        "path": "/emojies/smiling-I-am-pro.png",
        "description": "Confident smiling expression"
      },
      {
        "name": "smiling-mouth-open",
        "filename": "smiling-mouth-open.png",
        "path": "/emojies/smiling-mouth-open.png",
        "description": "Smiling with mouth open"
      },
      {
        "name": "smiling-no-glasses",
        "filename": "smiling-no-glasses.png",
        "path": "/emojies/smiling-no-glasses.png",
        "description": "Smiling without glasses"
      },
      {
        "name": "smiling-one-eyebrow-higher",
        "filename": "smiling-one-eyebrow-higher.png",
        "path": "/emojies/smiling-one-eyebrow-higher.png",
        "description": "Smiling with one eyebrow raised"
      },
      {
        "name": "satisfied-eye-closed",
        "filename": "satisfied-eye-closed.png",
        "path": "/emojies/satisfied-eye-closed.png",
        "description": "Satisfied with eyes closed"
      },
      {
        "name": "exclaimation-happy",
        "filename": "exclaimation-happy.png",
        "path": "/emojies/exclaimation-happy.png",
        "description": "Happy with exclamation"
      }
    ],
    "cool": [
      {
        "name": "cool",
        "filename": "cool.png",
        "path": "/emojies/cool.png",
        "description": "Cool expression"
      },
      {
        "name": "cool-side-eye",
        "filename": "cool-side-eye.png",
        "path": "/emojies/cool-side-eye.png",
        "description": "Cool with side eye"
      },
      {
        "name": "cool-sunglasses",
        "filename": "cool-sunglasses.png",
        "path": "/emojies/cool-sunglasses.png",
        "description": "Cool with sunglasses"
      },
      {
        "name": "cool-wow",
        "filename": "cool-wow.png",
        "path": "/emojies/cool-wow.png",
        "description": "Cool wow expression"
      }
    ],
    "sad": [
      {
        "name": "crying-sad",
        "filename": "crying-sad.png",
        "path": "/emojies/crying-sad.png",
        "description": "Crying sad expression"
      },
      {
        "name": "crying-sad-blue-crying",
        "filename": "crying-sad-blue-crying.png",
        "path": "/emojies/crying-sad-blue-crying.png",
        "description": "Very sad crying"
      },
      {
        "name": "crying-screaming",
        "filename": "crying-screaming.png",
        "path": "/emojies/crying-screaming.png",
        "description": "Crying and screaming"
      },
      {
        "name": "one-eye-crying",
        "filename": "one-eye-crying.png",
        "path": "/emojies/one-eye-crying.png",
        "description": "Crying with one eye"
      },
      {
        "name": "man-full-body-sad-sitting",
        "filename": "man-full-body-sad-sitting.png",
        "path": "/emojies/man-full-body-sad-sitting.png",
        "description": "Full body sad sitting"
      },
      {
        "name": "disappointed",
        "filename": "disappointed.png",
        "path": "/emojies/disappointed.png",
        "description": "Disappointed expression"
      }
    ],
    "surprised": [
      {
        "name": "wow",
        "filename": "wow.png",
        "path": "/emojies/wow.png",
        "description": "Wow expression"
      },
      {
        "name": "man-full-body-shocked",
        "filename": "man-full-body-shocked.png",
        "path": "/emojies/man-full-body-shocked.png",
        "description": "Full body shocked"
      },
      {
        "name": "eye-brows-up-in-the-middle",
        "filename": "eye-brows-up-in-the-middle.png",
        "path": "/emojies/eye-brows-up-in-the-middle.png",
        "description": "Eyebrows raised in surprise"
      }
    ],
    "confused": [
      {
        "name": "question",
        "filename": "question.png",
        "path": "/emojies/question.png",
        "description": "Question expression"
      },
      {
        "name": "question-finger-on-mouth",
        "filename": "question-finger-on-mouth.png",
        "path": "/emojies/question-finger-on-mouth.png",
        "description": "Question with finger on mouth"
      },
      {
        "name": "man-full-body-with-question-mark",
        "filename": "man-full-body-with-question-mark.png",
        "path": "/emojies/man-full-body-with-question-mark.png",
        "description": "Full body with question mark"
      },
      {
        "name": "what",
        "filename": "what.png",
        "path": "/emojies/what.png",
        "description": "What expression"
      }
    ],
    "tired": [
      {
        "name": "tired",
        "filename": "tired.png",
        "path": "/emojies/tired.png",
        "description": "Tired expression"
      },
      {
        "name": "worried-tired",
        "filename": "worried-tired.png",
        "path": "/emojies/worried-tired.png",
        "description": "Worried and tired"
      }
    ],
    "worried": [
      {
        "name": "worried-concerned",
        "filename": "worried-concerned.png",
        "path": "/emojies/worried-concerned.png",
        "description": "Worried and concerned"
      },
      {
        "name": "stressed",
        "filename": "stressed.png",
        "path": "/emojies/stressed.png",
        "description": "Stressed expression"
      }
    ],
    "angry": [
      {
        "name": "angry",
        "filename": "angry.png",
        "path": "/emojies/angry.png",
        "description": "Angry expression"
      }
    ],
    "ashamed": [
      {
        "name": "ashamed",
        "filename": "ashamed.png",
        "path": "/emojies/ashamed.png",
        "description": "Ashamed expression"
      },
      {
        "name": "covering-eyes",
        "filename": "covering-eyes.png",
        "path": "/emojies/covering-eyes.png",
        "description": "Covering eyes"
      },
      {
        "name": "man-full-body-covering-his-eyes",
        "filename": "man-full-body-covering-his-eyes.png",
        "path": "/emojies/man-full-body-covering-his-eyes.png",
        "description": "Full body covering eyes"
      },
      {
        "name": "covering-mouth",
        "filename": "covering-mouth.png",
        "path": "/emojies/covering-mouth.png",
        "description": "Covering mouth"
      }
    ],
    "sick": [
      {
        "name": "man-full-body-covering-his-face-sick",
        "filename": "man-full-body-covering-his-face-sick.png",
        "path": "/emojies/man-full-body-covering-his-face-sick.png",
        "description": "Full body sick covering face"
      },
      {
        "name": "something-is-wrong",
        "filename": "something-is-wrong.png",
        "path": "/emojies/something-is-wrong.png",
        "description": "Something is wrong"
      }
    ],
    "neutral": [
      {
        "name": "fine",
        "filename": "fine.png",
        "path": "/emojies/fine.png",
        "description": "Fine expression"
      },
      {
        "name": "whatever",
        "filename": "whatever.png",
        "path": "/emojies/whatever.png",
        "description": "Whatever expression"
      },
      {
        "name": "thinking-seriously",
        "filename": "thinking-seriously.png",
        "path": "/emojies/thinking-seriously.png",
        "description": "Thinking seriously"
      },
      {
        "name": "mough-closed-smiling",
        "filename": "mough-closed-smiling.png",
        "path": "/emojies/mough-closed-smiling.png",
        "description": "Mouth closed smiling"
      },
      {
        "name": "mixed-eyebrows",
        "filename": "mixed-eyebrows.png",
        "path": "/emojies/mixed-eyebrows.png",
        "description": "Mixed eyebrows expression"
      }
    ],
    "positive": [
      {
        "name": "energy",
        "filename": "energy.png",
        "path": "/emojies/energy.png",
        "description": "High energy"
      },
      {
        "name": "man-full-body-cool-thumbs-up",
        "filename": "man-full-body-cool-thumbs-up.png",
        "path": "/emojies/man-full-body-cool-thumbs-up.png",
        "description": "Full body thumbs up"
      },
      {
        "name": "man-full-body-dancing-hands-up",
        "filename": "man-full-body-dancing-hands-up.png",
        "path": "/emojies/man-full-body-dancing-hands-up.png",
        "description": "Full body dancing"
      },
      {
        "name": "man-full-body-danding-blinking",
        "filename": "man-full-body-danding-blinking.png",
        "path": "/emojies/man-full-body-danding-blinking.png",
        "description": "Full body dancing blinking"
      },
      {
        "name": "man-full-body-showing-his-two-fingers-up-peace",
        "filename": "man-full-body-showing-his-two-fingers-up-peace.png",
        "path": "/emojies/man-full-body-showing-his-two-fingers-up-peace.png",
        "description": "Full body peace sign"
      },
      {
        "name": "full-body-man-muscle",
        "filename": "full-body-man-muscle.png",
        "path": "/emojies/full-body-man-muscle.png",
        "description": "Full body showing muscle"
      },
      {
        "name": "full-body-two-point-fingers-touching",
        "filename": "full-body-two-point-fingers-touching.png",
        "path": "/emojies/full-body-two-point-fingers-touching.png",
        "description": "Full body two fingers touching"
      },
      {
        "name": "man-full-body-showing-his-two-point-fingers-like-praying",
        "filename": "man-full-body-showing-his-two-point-fingers-like-praying.png",
        "path": "/emojies/man-full-body-showing-his-two-point-fingers-like-praying.png",
        "description": "Full body praying gesture"
      }
    ],
    "negative": [
      {
        "name": "man-full-body-showing-his-thumb-down",
        "filename": "man-full-body-showing-his-thumb-down.png",
        "path": "/emojies/man-full-body-showing-his-thumb-down.png",
        "description": "Full body thumbs down"
      },
      {
        "name": "man-full-body-not-my-responsibility-sitting",
        "filename": "man-full-body-not-my-responsibility-sitting.png",
        "path": "/emojies/man-full-body-not-my-responsibility-sitting.png",
        "description": "Full body not my responsibility"
      }
    ],
    "other": [
      {
        "name": "man-full-body-setting-on-his-feet",
        "filename": "man-full-body-setting-on-his-feet.png",
        "path": "/emojies/man-full-body-setting-on-his-feet.png",
        "description": "Full body sitting on feet"
      },
      {
        "name": "blinking-longer-beard",
        "filename": "blinking-longer-beard.png",
        "path": "/emojies/blinking-longer-beard.png",
        "description": "Blinking with longer beard"
      },
      {
        "name": "sorry",
        "filename": "sorry.png",
        "path": "/emojies/sorry.png",
        "description": "Sorry expression"
      }
    ]
  },
  "all": [
    "angry",
    "ashamed",
    "blinking-happy",
    "blinking-longer-beard",
    "cool-side-eye",
    "cool-sunglasses",
    "cool-wow",
    "cool",
    "covering-eyes",
    "covering-mouth",
    "crying-sad-blue-crying",
    "crying-sad",
    "crying-screaming",
    "disappointed",
    "energy",
    "exclaimation-happy",
    "eye-brows-up-in-the-middle",
    "fine",
    "full-body-man-muscle",
    "full-body-two-point-fingers-touching",
    "happy-energy",
    "happy-looking-to-right",
    "happy-tongue-out",
    "laughing-crying",
    "laughing",
    "man-full-body-cool-thumbs-up",
    "man-full-body-covering-his-eyes",
    "man-full-body-covering-his-face-sick",
    "man-full-body-dancing-hands-up",
    "man-full-body-danding-blinking",
    "man-full-body-not-my-responsibility-sitting",
    "man-full-body-sad-sitting",
    "man-full-body-setting-on-his-feet",
    "man-full-body-shocked",
    "man-full-body-showing-his-thumb-down",
    "man-full-body-showing-his-two-fingers-up-peace",
    "man-full-body-showing-his-two-point-fingers-like-praying",
    "man-full-body-with-question-mark",
    "mixed-eyebrows",
    "mough-closed-smiling",
    "one-eye-crying",
    "question-finger-on-mouth",
    "question",
    "satisfied-eye-closed",
    "smiling-I-am-pro",
    "smiling-mouth-open",
    "smiling-no-glasses",
    "smiling-one-eyebrow-higher",
    "something-is-wrong",
    "sorry",
    "stressed",
    "thinking-seriously",
    "tired",
    "what",
    "whatever",
    "worried-concerned",
    "worried-tired",
    "wow"
  ]
}







